import React from 'react';
// import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
// import { Location } from '@reach/router';

import { Helmet } from 'react-helmet';
import App from '../components/App';
import { headData } from '../mock/data';
import twitter from '../components/Seo/Twitter';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style/main.scss';


export default ({ data }) => {
  const { title, lang, description } = headData;
  // const [rootUrl, setRootUrl] = useState('');
  // console.log('pathnamed', rootUrl);
  console.log('dd', data);
  const twitterData = twitter({ data });

  const meta = (() => {
    const d = [
      {
        name: 'description',
        content: description,
      },
    ];
    return d.concat(twitterData);
  })();

  return (
    <>
      <Helmet
        htmlAttributes={{ lang: lang || 'ja' }}
        title={title || 'Gatsby Simplefolio'}
        meta={meta}
      />
      <App />
    </>
  );
};


// <meta charSet="utf-8" />
// <title>{title || 'Gatsby Simplefolio'}</title>
// <html lang={lang || 'en'} />
// <meta name="description" content={description || 'Gatsby Simplefolio'} />
// {twitterData.map((d) => (
//   <meta key={d.key} name={d.name} content={d.content} property={d.property} />
// ))}
// </Helmet>

export const query = graphql`
  {
    allFile {
      nodes {
        publicURL
        base
      }
    }
  }
`;
